
const TimesheetLegend = () => {
  return (
    <ul className="legend">
      <li>
        <span className="legend-code">[A]</span> Ausências |
      </li>
      <li>
        <span className="legend-code">[F]</span> Férias |
      </li>
      <li>
        <span className="legend-code">[H]</span> Feriados |
      </li>
      <li>
        <span className="legend-code">[D]</span> Domingo |
      </li>
      <li>
        <span className="legend-code">[S]</span> Sábado |
      </li>
      <li>
        <span className="legend-code">[D.T.]</span> Dias trabalhados |
      </li>
      <li>
        <span className="legend-code">[D.M.]</span> Dias úteis do mês |
      </li>
      <li>
        <span className="legend-code">[H.T.]</span> Horas trabalhadas |
      </li>
      <li>
        <span className="legend-code">[H.M.]</span> Horas úteis do mês |
      </li>
      <li>
        <span className="legend-code">[D.A.]</span> Dias ausente |
      </li>
      <li>
        <span className="legend-code">[P.T.]</span> % Horas trabalhadas |
      </li>
      <li>
        <span className="legend-code">[P.A.]</span> % Horas ausentes |
      </li>
    </ul>
  );
};

export default TimesheetLegend;